import { useState, useEffect } from 'react';
import skullImg from '../assets/side-skull.png';
import messageImg from '../assets/message.png';
import { Button } from './button/Button';
import styles from './KillRequestOverlay.module.css';

type Props = {
  killerName: string | null;
  onAccept: () => void;
  onDecline: () => void;
};

export function KillRequestOverlay({ killerName, onAccept, onDecline }: Props) {
  const [showBubble, setShowBubble] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowBubble(true), 850);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={styles.overlay}>
      <img src={skullImg} className={styles.skull} alt="" />
      {showBubble && (
        <div className={styles.bubbleWrapper}>
          <img src={messageImg} className={styles.bubbleImg} alt="" />
          <div className={styles.bubbleContent}>
            <p className={styles.killerText}>
              {killerName ?? 'Someone'} claims
              <br />
              they eliminated you.
            </p>
            <div className={styles.buttons}>
              <Button onClick={onAccept}>Accept</Button>
              <Button variant="secondary" onClick={onDecline}>
                Decline
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
